export let allItems = {
  content: [
    {
      id: '646c9970264add7aa2fe2f71',
      jobId: 57,
      createdDate: 1684408040105,
      clientId: '0c7ea226-a911-4940-b831-94a59a3bbf1c',
      itemName: 'Butterfly Lemonade 4',
      itemPrice: 5.75,
      groupNames: ['Lemonade', 'ADD'],
      locationId: 'dsfsdfs346-a911-4940-b831-94a59aefdfss',
      totalVolumeSold: {
        all: 16,
        good: 6,
        bad: 10,
      },
      volumeSoldLastMonth: {
        all: 0,
        good: 0,
        bad: 0,
      },
      volumeSoldPerMonth: {
        all: 1.30434782608696,
        good: 0.489130434782609,
        bad: 0.815217391304348,
      },
      volumeSoldBreakfast: {
        all: 0,
        good: 0,
        bad: 0,
      },
      volumeSoldLunch: {
        all: 7,
        good: 1,
        bad: 6,
      },
      volumeSoldDinner: {
        all: 9,
        good: 5,
        bad: 4,
      },
      customerPercentage: {
        all: 2.8436018957346,
        good: 3.33333333333333,
        bad: 1.65876777251185,
      },
      avgOrdersPerMonth: {
        all: 0.269082714981581,
        good: 0.370655850050274,
        bad: 0.196530475646801,
      },
      indexMetricOverUnderIndexValue: 0.719478908188586,
      indexMetricOverUnderState: 'bad_high_good_low',
      itemScore: 19.6027388227735,
      itemImageUrl: null,
    },
    {
      id: '646c9970264add7aa2fe2f69',
      jobId: 57,
      createdDate: 1684408040105,
      clientId: '0c7ea226-a911-4940-b831-94a59a3bbf1c',
      itemName: 'Butterfly Lemonade 3',
      itemPrice: 5.8,
      groupNames: ['Lemonade'],
      locationId: 'dsfsdfs346-a911-4940-b831-94a59aefdfss',
      totalVolumeSold: {
        all: 16,
        good: 6,
        bad: 10,
      },
      volumeSoldLastMonth: {
        all: 0,
        good: 0,
        bad: 0,
      },
      volumeSoldPerMonth: {
        all: 1.30434782608696,
        good: 0.489130434782609,
        bad: 0.815217391304348,
      },
      volumeSoldBreakfast: {
        all: 0,
        good: 0,
        bad: 0,
      },
      volumeSoldLunch: {
        all: 7,
        good: 1,
        bad: 6,
      },
      volumeSoldDinner: {
        all: 9,
        good: 5,
        bad: 4,
      },
      customerPercentage: {
        all: 2.8436018957346,
        good: 3.33333333333333,
        bad: 1.65876777251185,
      },
      avgOrdersPerMonth: {
        all: 0.269082714981581,
        good: 0.370655850050274,
        bad: 0.196530475646801,
      },
      indexMetricOverUnderIndexValue: 0.719478908188586,
      indexMetricOverUnderState: 'bad_high_good_low',
      itemScore: 48.6027388227735,
      itemImageUrl:
        'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/download_34375064aabe49c7b1c6de9590d569c2.jpg',
    },
    {
      id: '646c996f264add7aa2fe2f62',
      jobId: 57,
      createdDate: 1684408040105,
      clientId: '0c7ea226-a911-4940-b831-94a59a3bbf1c',
      itemName: 'Butterfly Lemonade 2',
      itemPrice: 4.75,
      groupNames: ['Lemonade', 'NO', 'ADD'],
      locationId: 'dsfsdfs346-a911-4940-b831-94a59aefdfss',
      totalVolumeSold: {
        all: 16,
        good: 6,
        bad: 10,
      },
      volumeSoldLastMonth: {
        all: 0,
        good: 0,
        bad: 0,
      },
      volumeSoldPerMonth: {
        all: 1.30434782608696,
        good: 0.489130434782609,
        bad: 0.815217391304348,
      },
      volumeSoldBreakfast: {
        all: 0,
        good: 0,
        bad: 0,
      },
      volumeSoldLunch: {
        all: 7,
        good: 1,
        bad: 6,
      },
      volumeSoldDinner: {
        all: 9,
        good: 5,
        bad: 4,
      },
      customerPercentage: {
        all: 2.8436018957346,
        good: 3.33333333333333,
        bad: 1.65876777251185,
      },
      avgOrdersPerMonth: {
        all: 0.269082714981581,
        good: 0.370655850050274,
        bad: 0.196530475646801,
      },
      indexMetricOverUnderIndexValue: 0.719478908188586,
      indexMetricOverUnderState: 'bad_high_good_low',
      itemScore: 87.6027388227735,
      itemImageUrl:
        'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/download_34375064aabe49c7b1c6de9590d569c2.jpg',
    },
    {
      id: '646c996f264add7aa2fe2f58',
      jobId: 57,
      createdDate: 1684408040105,
      clientId: '0c7ea226-a911-4940-b831-94a59a3bbf1c',
      itemName: 'Butterfly Lemonade 1',
      itemPrice: 7.75,
      groupNames: ['Lemonade', 'ADD'],
      locationId: 'dsfsdfs346-a911-4940-b831-94a59aefdfss',
      totalVolumeSold: {
        all: 16,
        good: 6,
        bad: 10,
      },
      volumeSoldLastMonth: {
        all: 0,
        good: 0,
        bad: 0,
      },
      volumeSoldPerMonth: {
        all: 1.30434782608696,
        good: 0.489130434782609,
        bad: 0.815217391304348,
      },
      volumeSoldBreakfast: {
        all: 0,
        good: 0,
        bad: 0,
      },
      volumeSoldLunch: {
        all: 7,
        good: 1,
        bad: 6,
      },
      volumeSoldDinner: {
        all: 9,
        good: 5,
        bad: 4,
      },
      customerPercentage: {
        all: 2.8436018957346,
        good: 3.33333333333333,
        bad: 1.65876777251185,
      },
      avgOrdersPerMonth: {
        all: 0.269082714981581,
        good: 0.370655850050274,
        bad: 0.196530475646801,
      },
      indexMetricOverUnderIndexValue: 0.719478908188586,
      indexMetricOverUnderState: 'bad_high_good_low',
      itemScore: 16.6027388227735,
      itemImageUrl:
        'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/download_34375064aabe49c7b1c6de9590d569c2.jpg',
    },
    {
      id: '646c996e264add7aa2fe2f4c',
      jobId: 57,
      createdDate: 1684408040105,
      clientId: '0c7ea226-a911-4940-b831-94a59a3bbf1c',
      itemName: 'Butterfly Lemonade',
      itemPrice: 8.75,
      groupNames: ['Lemonade', ''],
      locationId: 'dsfsdfs346-a911-4940-b831-94a59aefdfss',
      totalVolumeSold: {
        all: 16,
        good: 6,
        bad: 10,
      },
      volumeSoldLastMonth: {
        all: 0,
        good: 0,
        bad: 0,
      },
      volumeSoldPerMonth: {
        all: 1.30434782608696,
        good: 0.489130434782609,
        bad: 0.815217391304348,
      },
      volumeSoldBreakfast: {
        all: 0,
        good: 0,
        bad: 0,
      },
      volumeSoldLunch: {
        all: 7,
        good: 1,
        bad: 6,
      },
      volumeSoldDinner: {
        all: 9,
        good: 5,
        bad: 4,
      },
      customerPercentage: {
        all: 2.8436018957346,
        good: 3.33333333333333,
        bad: 1.65876777251185,
      },
      avgOrdersPerMonth: {
        all: 0.269082714981581,
        good: 0.370655850050274,
        bad: 0.196530475646801,
      },
      indexMetricOverUnderIndexValue: 0.719478908188586,
      indexMetricOverUnderState: 'bad_high_good_low',
      itemScore: 15.6027388227735,
      itemImageUrl:
        'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/download_34375064aabe49c7b1c6de9590d569c2.jpg',
    },
  ],
  totalElements: 5,
  totalPages: 1,
  last: true,
  size: 5,
  number: 0,
  first: true,
  sort: [
    {
      direction: 'DESC',
      property: 'itemScore',
      ignoreCase: false,
      nullHandling: 'NATIVE',
      ascending: false,
    },
  ],
  numberOfElements: 5,
};
